var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"width":"68%"},attrs:{"src":require("@/assets/images/basicInstruction.png"),"alt":"basic Instruction"}})}
var staticRenderFns = []

export { render, staticRenderFns }